export default __webpack_public_path__ + "static/media/me.ad07d330.webp";